import React from 'react';
import Hero from '../components/Hero';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import SitePartner from '../components/SitePartner';

const BusesPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 pb-20">
      <Hero 
        title="Transit & Buses" 
        imageUrl="https://res.cloudinary.com/dufyzcc72/image/upload/v1773316871/bus_jzsnj3.jpg"
      />
      <div className="max-w-2xl mx-auto px-4 mt-6">
        <SitePartner />
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white p-12 rounded-3xl shadow-xl border border-slate-100 text-center mt-4" >
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-8 uppercase tracking-tighter leading-tight"> Check if the buses are running today. </h2>
          <a href="https://www.facebook.com/T3Transit/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 w-full py-6 px-8 bg-blue-600 hover:bg-blue-700 text-white rounded-2xl transition-all shadow-xl active:scale-[0.97] text-2xl font-black text-center uppercase" >
            <span>Check on buses</span>
            <SafeIcon name="ExternalLink" className="text-xl" />
          </a>
          <p className="mt-8 text-slate-500 font-bold text-lg"> Visit the official T3 Transit Facebook page for the latest live updates. </p>
        </motion.div>
      </div>
    </div>
  );
};

export default BusesPage;